'use client';
export default function (props: any) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M3.5 5h17v1.5h-17zm0 6.5h17V13h-17zm0 6.5h17v1.5h-17z" fill="#000" />
        </svg>
    );
}
